<template>
  <div class="union-members-popup">
    <div class="union-member-icon" @click="clickUnionMemberIcon">
      <img :src="icon" alt="" />
      <span
        v-if="text"
        :style="{
          color: personInfo && personInfo.theme === 'light' ? '#404040' : '',
        }"
      >
        {{ text }}
      </span>
      <img
        v-if="unionMemberVisible"
        class="tips-icon"
        src="https://logo.wondercv.com/banners/zVswfHWcOlDA57S.png"
        alt=""
      />
    </div>
    <div
      v-if="popupVisible"
      class="union-member-wrapper"
      :class="{ empty: !unionMembers.length }"
    >
      <div v-if="unionMembers.length" class="union-member-content">
        <div class="header">
          <img
            src="https://logo.wondercv.com/banners/FYsfNBY6jZF4ZL1.png"
            alt=""
          />
          <span>{{ returnHeaderText }}</span>
          <img
            class="close-icon"
            src="https://logo.wondercv.com/banners/NEjtAXdicS2s5Wd.png"
            alt=""
            @click="popupVisible = false"
          />
        </div>
        <div class="list-content">
          <div
            v-for="(item, index) in unionMembers"
            :key="index"
            class="list-item"
          >
            <img :src="item.image" alt="" class="logo" />
            <div class="info">
              <span class="info-title">{{ item.title }}</span>
              <span class="info-desc" @click="toDetailUrl(item)">兑换说明</span>
            </div>
            <div
              class="btn"
              :class="{'disabled': item.code}"
              @click="clickRecieveBtn(item)"
            >
              {{ item.code ? '复制' : '领取' }}
            </div>
          </div>
        </div>
      </div>
      <template v-else-if="isMemberShip && !isForeverMember && lastOrderPaid">
        <img
          class="upgrade-member-icon"
          src="https://logo.wondercv.com/banners/xufHkWBSyEEGW9h.png"
          alt=""
        />
        <span class="buy-member-text">
          购买终身会员<br />解锁超多联合会员权益
        </span>
        <div class="upgrade-btn" @click="showAlert = true">立即解锁</div>
      </template>
      <template v-else>
        <img
          class="no-members"
          src="https://logo.wondercv.com/banners/KSNDbp0ALlv2I4Y.png"
          alt=""
        />
        <span class="empty-text">暂无可领取会员权益</span>
      </template>
      <img
        v-if="!unionMembers.length"
        class="close-icon"
        src="https://logo.wondercv.com/banners/NEjtAXdicS2s5Wd.png"
        alt=""
        @click="popupVisible = false"
      />
    </div>
    <pay-alert
      v-if="showAlert"
      @close="showAlert = false"
    />
  </div>
</template>
<script>
import api from "@/api";
import { get_tUser, routerTo, copyToClipboard } from "@/assets/js/util";
import { mapState } from "vuex";
import payAlert from "../../account/user/payAlert.vue";
const moment = require("moment");

const TODAY_STR = moment().format("YYYY/MM/DD");
export default {
  components: {
    payAlert,
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    storageKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      unionMembers: [],
      popupVisible: false,
      showAlert: false,
      unionMemberVisible: false,
      lastOrderPaid: false,
    };
  },
  computed: {
    ...mapState("me", ["personInfo"]),
    isForeverMember() {
      return (
        this.personInfo &&
        this.personInfo.is_membership &&
        this.personInfo.membership_expired_at.substr(0, 4) >= 2100
      );
    },
    isMemberShip() {
      return this.personInfo?.is_membership;
    },
    returnHeaderText() {
      const all = this.unionMembers.every(item => !!item.code)
      return all ? '您已领取所有会员权益' : '您还有以下会员权益未领取'
    }
  },
  methods: {
    clickUnionMemberIcon() {
      this.popupVisible = true;
      this.unionMemberVisible = false;
      if (this.unionMembers?.length) {
        localStorage.setItem(this.storageKey, TODAY_STR);
      }
    },
    async getUserUnionMembers() {
      try {
        const { c_t } = get_tUser() || {};
        if (!c_t) return console.log("cv account token is not found!");
        const res = await api.account.fetchAccountUnionMembers(c_t);
        if (res.code === 1000) {
          this.unionMembers = res.data.union_members;
          this.lastOrderPaid = res.data.last_order_paid;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toDetailUrl(data) {
      if (data.detail_url) {
        routerTo(data.detail_url, "_blank");
      }
    },
    async clickRecieveBtn(data) {
      try {
        if (data.code) {
          await copyToClipboard(data.code);
          return this.$message.success("兑换码已复制");
        }
        const res = await api.account.receiveUniMemberCode(
          data.improved_order_token,
          data.id
        );
        if (res.code === 1000) {
          await copyToClipboard(res.data.code);
          this.$message.success("领取成功，兑换码已复制");
          this.getUserUnionMembers();
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.getUserUnionMembers();
    const STORAGE_STR = localStorage.getItem(this.storageKey);
    this.unionMemberVisible =
      !!this.unionMembers?.length && TODAY_STR !== STORAGE_STR;
  },
};
</script>
<style lang="scss" scoped>
.union-members-popup {
  .union-member-icon {
    position: fixed;
    right: 30px;
    bottom: 212px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 199;
    img {
      width: 52px;
      height: 52px;
    }
    span {
      font-size: 12px;
      color: #fff;
      margin-top: 8px;
    }
    .tips-icon {
      position: absolute;
      bottom: calc(100% + 4px);
      left: 50%;
      transform: translate(-50%);
      width: 90px;
      height: 40px;
      object-fit: contain;
    }
  }
  .union-member-wrapper {
    position: fixed;
    bottom: 70px;
    right: 110px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 4px 20px 0px rgba(42, 47, 86, 0.12);
    border-radius: 8px;
    overflow: hidden;
    width: 300px;
    height: 440px;
    z-index: 199;
    cursor: pointer;
    &.empty {
      height: 300px;
    }
    .union-member-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      .header {
        position: relative;
        display: flex;
        align-items: center;
        padding: 14px 16px;
        background-color: #fff7e8;
        box-sizing: border-box;
        width: 100%;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        span {
          color: #fc7032;
          font-size: 14px;
          line-height: 14px;
          font-weight: 500;
        }
        .close-icon {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 16px;
          width: 14px;
          height: 14px;
          margin-right: 0;
        }
      }
      .list-content {
        padding: 0 16px;
        overflow-y: scroll;
        height: calc(440px - 52px);
        &::-webkit-scrollbar {
          display: none;
        }
        .list-item {
          position: relative;
          display: flex;
          align-items: center;
          height: 72px;
          border: 1px solid #ececec;
          border-radius: 8px;
          margin-bottom: 12px;
          padding-left: 14px;
          &:first-child {
            margin-top: 16px;
          }
          &:last-child {
            margin-bottom: 16px;
          }
          .logo {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            border: 1px solid #d9d9d9;
            margin-right: 12px;
          }
          .info {
            display: flex;
            flex-direction: column;
            .info-title {
              color: #3a3f59;
              font-size: 16px;
              line-height: 16px;
              font-weight: 500;
              margin-bottom: 6px;
            }
            .info-desc {
              font-size: 12px;
              color: #61657b;
              text-decoration-line: underline;
              line-height: 12px;
            }
          }
          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 17px;
            right: 14px;
            border-radius: 100px;
            background-color: #ff6644;
            font-size: 12px;
            color: #fff;
            font-weight: 500;
            width: 48px;
            height: 20px;
            cursor: pointer;
            &.disabled {
              background-color: #EEEEEE;
              color: #9E9E9E;
            }
          }
        }
      }
    }
    .upgrade-member-icon {
      width: 100px;
      height: 100px;
      margin-bottom: 16px;
    }
    .buy-member-text {
      font-size: 14px;
      color: #404040;
      line-height: 18px;
      text-align: center;
      margin-bottom: 24px;
    }
    .upgrade-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 24px;
      border-radius: 100px;
      background: linear-gradient(180deg, #ff986f 0%, #ff5935 100%);
      color: #fff;
      font-weight: 500;
      cursor: pointer;
    }
    .no-members {
      width: 80px;
      height: 80px;
      margin-bottom: 16px;
    }
    .empty-text {
      font-size: 14px;
      color: #aeaeae;
    }
    .close-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
}
</style>
